<template>
  <div class="buttons-set">
    <div class="buttons-set__wrapper">
      <div v-if="$slots['side']" class="buttons-set__side">
        <slot name="side"/>
      </div>
      <div v-if="$slots['main']" class="buttons-set__main">
        <slot name="main"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonsSet'
}
</script>
